import { commonComponents as cc } from "./common";
import { formComponents as fc } from "./form";
import { ui } from "./ui";

export const components = { cc, fc, ui };
